var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.892,
    height: 18.691,
    viewBox: "0 0 15.892 18.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5451",
    "data-name": "Rectangle 5451",
    width: 15.892,
    height: 18.691,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15555",
    "data-name": "Group 15555",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15554",
    "data-name": "Group 15554",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29538",
    "data-name": "Path 29538",
    d: "M15.23,5.338H13.244V4A4.015,4.015,0,0,0,11.416.634a3.937,3.937,0,0,0-3.8-.268,3.937,3.937,0,0,0-3.8.268A4.015,4.015,0,0,0,1.987,4V5.338H.662A.665.665,0,0,0,0,6.006V18.024a.665.665,0,0,0,.662.668H15.23a.665.665,0,0,0,.662-.668V6.006a.665.665,0,0,0-.662-.668M11.919,4V5.338H9.933V4a4.01,4.01,0,0,0-.986-2.636,2.062,2.062,0,0,1,.324-.035A2.661,2.661,0,0,1,11.919,4m-5.3,0a2.672,2.672,0,0,1,.993-2.069A2.672,2.672,0,0,1,8.608,4V5.338H6.622ZM3.311,4A2.661,2.661,0,0,1,5.96,1.333a2.062,2.062,0,0,1,.324.035A4.01,4.01,0,0,0,5.3,4V5.338H3.311ZM1.324,6.674h9.271V17.356H1.324ZM14.568,17.356H11.919V6.674h2.649Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart_icon.73a51e77b5909981ab2462f114e834f3.svg";
export { ForwardRef as ReactComponent };